module.exports = __webpack_public_path__ + "img/pay-tmp-detail.4da632f3.png";